import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Sparkles } from 'lucide-react';
import { createGame } from '../lib/store';
import { PLACEHOLDER_GAME } from '../lib/runtime';

const GENRES = ['Shoot \'em up', 'Platform', 'One-Tap', 'Twin-Stick', 'Puzzle', 'Racing', 'Roguelite', 'Arcade'];

export default function NewGameDialog({ open, onOpenChange, onCreated }) {
  const [title, setTitle] = useState('');
  const [genre, setGenre] = useState('Arcade');
  const [idea, setIdea] = useState('');

  const submit = async () => {
    const t = title.trim() || 'Nuova Forgia';
    const g = await createGame({ title: t, genre, code: PLACEHOLDER_GAME, label: 'Forgia vuota', blank: true });
    const prompt = idea.trim() ? `Crea da zero un gioco "${t}" (genere: ${genre}). Idea: ${idea.trim()}` : null;
    setTitle(''); setIdea('');
    onOpenChange(false);
    onCreated(g, prompt);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-game-dialog" className="bg-titan-surface border-violet-500/30 max-w-lg">
        <DialogHeader>
          <DialogTitle>Forgia un nuovo gioco</DialogTitle>
          <DialogDescription className="t-chat">Descrivi l'idea: THE ARCHITECT progetterà meccaniche, codice e juice in un unico file HTML.</DialogDescription>
        </DialogHeader>
        <Input data-testid="new-game-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Titolo (es. Astro Rush)" />
        <div className="flex flex-wrap gap-2">
          {GENRES.map((x) => (
            <button key={x} data-testid={`genre-${x.replace(/\W+/g, '-').toLowerCase()}`} onClick={() => setGenre(x)}
              className={`rounded-full px-3 py-1 text-xs border transition-colors ${genre === x ? 'bg-cyan-500/20 border-cyan-400 text-cyan-100' : 'border-slate-700 text-slate-400 hover:border-slate-500'}`}>{x}</button>
          ))}
        </div>
        <Textarea data-testid="new-game-idea" value={idea} onChange={(e) => setIdea(e.target.value)} className="h-28 t-chat text-sm"
          placeholder="Es: astronave che schiva asteroidi, power-up scudo, boss ogni 5 ondate, difficoltà crescente…" />
        <button data-testid="new-game-submit" onClick={submit} className="flex items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-bold bg-gradient-to-r from-violet-600 to-cyan-600 hover:brightness-110 transition-[filter]">
          <Sparkles className="h-4 w-4" /> {idea.trim() ? 'Forgia con THE ARCHITECT' : 'Crea forgia vuota'}
        </button>
      </DialogContent>
    </Dialog>
  );
}
